<template>
<div class="dt-action-btns">
    <b-dropdown v-if="dropdownBtns.length > 1" variant="outline-primary" right split :text="mainActionBtn.text"  @click="itemAction(mainActionBtn.action, rowData, rowIndex)" >
        <b-dropdown-item v-for="item in dropdownBtns"
            :key="item.action"
            class="w-100"
            @click="itemAction(item.action, rowData, rowIndex)">
            {{ item.text }}
        </b-dropdown-item>
    </b-dropdown>
    <b-button v-else-if="mainActionBtn.text" variant="outline-primary" class="btn-sm w-100" @click="itemAction(mainActionBtn.action, rowData, rowIndex)">{{ mainActionBtn.text }}</b-button>
    <i v-else-if="mainActionBtn.icon" @click="itemAction(mainActionBtn.action, rowData, rowIndex)" :class="`actionIcon ${mainActionBtn.icon}`"></i>

</div>
</template>

<script>

export default {
    props: {
        rowData: {
            type: Object,
            required: true
        },
        rowIndex: {
            type: Number
        }
    },
    computed: {
        mainActionBtn() {
            return typeof this.rowData.actions != 'undefined' && this.rowData.actions && this.rowData.actions.length ? this.rowData.actions[0] : null;
        },
        dropdownBtns() {
            var items = [];
        
            if (this.rowData.actions)
                items = [...this.rowData.actions];
            
            // if (items.length > 1 )
            //     items.splice(0,1)
                 
            return items;
        }
    },
    methods: {
        itemAction(action, data, index) {
            this.$parent.$emit('btn-clicked',{
                action:action,
                data:data,
                index:index
            });
        }
    }
}
</script>

<style>
.dt-action-btns button.ui.button {
    padding: 8px 8px;
}

.dt-action-btns button.ui.button > i.icon {
    margin: auto !important;
}
.actionIcon {
  cursor: pointer;
}
</style>
